module.exports = __webpack_public_path__ + "static/cashback-banner-3-43e4b23d0cc2a2991360fc5f7b430c1a.png";